<template>
	<div class="teaming-layout goals-body">
		<section class="goals-body__toolbar">
			<slot name="toolbar"></slot>
		</section>
		<main class="goals-body__details">
			<slot name="details"></slot>
		</main>
	</div>
</template>

<script>

export default {
	name: "MyGoalsBody",
};
</script>

<style lang="scss" scoped>
.goals-body {
	// dock to the sublayout body; content within the details
	// will scroll, but toolbar remains fixed
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	width: 100%;

	// internal layout is flex
	display: flex;
	flex-direction: column;
	justify-content: flex-start;

	padding: 1rem;

	@include for-size('md') {
		padding: 2rem;
	}
}

.goals-body__toolbar {
	padding-bottom: 1rem;

	@include for-size('md') {
		padding-bottom: 2rem;
	}
}

.goals-body__details {
	// assume that detail content will control its own scrolling
	position: relative;
	overflow: hidden;

	display: flex;
	flex-direction: column;
	// take up the remaining vertical space
	flex: 1;
}
</style>
